var woocommerceCheckout = {
    $woocommercecheckout: $('.woocommerce-checkout'),

    init: function() {
        var _this = this;
        if (!_this.$woocommercecheckout.length) {
            return;
        }
        _this.$idealSelect = _this.$woocommercecheckout.find(
            'select[name=mollie-payments-for-woocommerce_issuer_mollie_wc_gateway_ideal]'
        );
        _this.$idealSelect.selectric({
            arrowButtonMarkup: '<div class="button icon icon-arrow-down-purple"></div>'
        });
    }
};
